/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ToolFilterOptions } from '../models/ToolFilterOptions';
import type { Tools } from '../models/Tools';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ToolInventoryService {
    /**
     * list inventories
     * @param year
     * @param page
     * @param billable
     * @param categoryId
     * @param limit
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @param inventoried
     * @returns Tools successful
     * @throws ApiError
     */
    public static getInventory(
        year: number,
        page?: number,
        billable?: boolean,
        categoryId?: string,
        limit?: number,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
        inventoried?: boolean,
    ): CancelablePromise<Tools> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories',
            query: {
                'year': year,
                'page': page,
                'billable': billable,
                'category_id': categoryId,
                'limit': limit,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
                'inventoried': inventoried,
            },
        });
    }
    /**
     * filter options
     * @param year
     * @param billable
     * @param categoryId
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @param inventoried
     * @returns ToolFilterOptions successful
     * @throws ApiError
     */
    public static getFilterOptions(
        year: number,
        billable?: boolean,
        categoryId?: string,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
        inventoried?: boolean,
    ): CancelablePromise<ToolFilterOptions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories/filter_options',
            query: {
                'year': year,
                'billable': billable,
                'category_id': categoryId,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
                'inventoried': inventoried,
            },
        });
    }
    /**
     * export inventory as csv
     * @param year
     * @param billable
     * @param categoryId
     * @param searchText
     * @param serialNumber
     * @param withoutResponsibleEmployee
     * @param responsibilityStatesArray
     * @param responsibleEmployeeIdsArray
     * @param managerIdsArray
     * @param tenantIdsArray
     * @param abbreviationsArray
     * @param inventoried
     * @returns binary successfully sends export data
     * @throws ApiError
     */
    public static exportInventory(
        year: number,
        billable?: boolean,
        categoryId?: string,
        searchText?: string,
        serialNumber?: string,
        withoutResponsibleEmployee?: boolean,
        responsibilityStatesArray?: Array<'available' | 'assigned' | 'taken'>,
        responsibleEmployeeIdsArray?: Array<string>,
        managerIdsArray?: Array<string>,
        tenantIdsArray?: Array<string>,
        abbreviationsArray?: Array<string>,
        inventoried?: boolean,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resources/tool_administration/inventories/export',
            query: {
                'year': year,
                'billable': billable,
                'category_id': categoryId,
                'search_text': searchText,
                'serial_number': serialNumber,
                'without_responsible_employee': withoutResponsibleEmployee,
                'responsibility_states[]': responsibilityStatesArray,
                'responsible_employee_ids[]': responsibleEmployeeIdsArray,
                'manager_ids[]': managerIdsArray,
                'tenant_ids[]': tenantIdsArray,
                'abbreviations[]': abbreviationsArray,
                'inventoried': inventoried,
            },
        });
    }
}
